import { Alert, AlertTitle } from '@/view/components/ui/alert'
import { Button } from '@/view/components/ui/button'
import { Checkbox } from '@/view/components/ui/checkbox'
import { Separator } from '@/view/components/ui/separator'
import { TriangleAlert } from 'lucide-react'
import { useLiveFormContext } from '../../providers/LiveFormProvider'
import { useState } from 'react'

interface StepProps {
  description: string
  label: string
}

const Step = ({ description, label }: StepProps) => {
  return (
    <div className="flex items-start gap-3">
      <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border font-bold text-primary">
        {label}
      </div>
      <p>{description}</p>
    </div>
  )
}

export const AlertStep = () => {
  const { markDontShowMessageAgain, setStep } = useLiveFormContext()
  const [dontShowAgain, setDontShowAgain] = useState(false)

  const handleCheck = (value: boolean) => setDontShowAgain(value)

  const handleSubmit = () => {
    if (dontShowAgain) {
      markDontShowMessageAgain()
      return
    }
    setStep(1)
  }

  return (
    <>
      <Alert className="my-8 border-yellow-500 bg-yellow-100/30 p-5">
        <div className="mb-2 flex items-center gap-2">
          <TriangleAlert size={18} />
          <AlertTitle className="mb-0 font-semibold">Importante</AlertTitle>
        </div>

        <p className="mb-4 text-sm">
          Para realizar suas transmissões você precisará usar uma plataforma
          externa, como Zoom ou Google Meet.
        </p>
        <p className="text-sm font-semibold">
          Abaixo, fornecemos instruções para ajudá-lo a configurar sua
          transmissão.
        </p>
      </Alert>
      <Step
        label="1"
        description="Crie uma conta ou faça login na sua plataforma externa preferida (Zoom, Google Meet, etc.)"
      />
      <Separator orientation="vertical" className="ml-4 h-7" />
      <Step
        label="2"
        description="Agende sua transmissão na plataforma escolhida, especificando data e hora."
      />
      <Separator orientation="vertical" className="ml-4 h-7" />
      <Step
        label="3"
        description="Copie o link da transmissão e cole no campo “Link da Transmissão” do formulário a seguir."
      />

      <Button className="mt-8 rounded-full text-white" onClick={handleSubmit}>
        Entendido
      </Button>
      <div className="mt-4 flex items-center justify-center space-x-2">
        <Checkbox
          id="terms"
          checked={dontShowAgain}
          onCheckedChange={handleCheck}
        />
        <label
          htmlFor="terms"
          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          Não mostar novamente
        </label>
      </div>
    </>
  )
}
